import React, { useEffect } from 'react'
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { get_banners } from "../../redux/actions/home";



function Banner({ get_banners, banners }) {
    useEffect(() => {
        if (banners.length === 0) {
            get_banners();
        }
    }, [banners]);



    return (
        <>
            <div className="relative">
                <Swiper
                    loop={banners.length > 1}
                    slidesPerView={1}
                    slidesPerGroup={1}
                    spaceBetween={12}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        }
                    }}
                    navigation={{
                        nextEl: '.custom-next',
                        prevEl: '.custom-prev'
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="banner-Swiper"
                >
                    {
                        banners.map((banner) => (
                            <SwiperSlide className="!bg-transparent" key={banner.id}>
                                <div className="banner-slide-item">
                                    <div className="banner-container">
                                        <img
                                            src={banner.image_web}
                                            alt=""
                                            className="banner-img"
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    }

                </Swiper>
                <div className="custom-prev absolute left-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-md hover:bg-opacity-80">
                    ❮
                </div>
                <div className="custom-next absolute right-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-md hover:bg-opacity-80">
                    ❯
                </div>
            </div>
        </>
    );
}

const mapStateToProps = state => ({
    banners: state.Home.banners
})

export default connect(mapStateToProps, {
    get_banners
})(Banner)